export const classes = {
  item: 'flex flex-col mx-2 px-3.5 py-2 rounded-[10px] cursor-pointer select-none hover:bg-black/5',
  label: 'text-taupe-3 text-[13.5px] font-semibold',
  subtitle: 'text-taupe-2 text-[11.5px] mt-0.5',
};
